export const messages = {
  labels: {
    startDate: {
      id: 'treatmentSummary.Groups.RadiationTherapy.StartDate',
      defaultMessage: 'First Treatment: ',
    },
    endDate: {
      id: 'treatmentSummary.Groups.RadiationTherapy.EndDate',
      defaultMessage: 'Most Recent: ',
    },
    deliveredDose: {
      id: 'treatmentSummary.Groups.RadiationTherapy.DeliveredDose',
      defaultMessage: 'Dose Delivered: ',
    },
    deliveredFractions: {
      id: 'treatmentSummary.Groups.RadiationTherapy.DeliveredFractions',
      defaultMessage: 'Fractions: ',
    },
    radiationType: {
      id: 'treatmentSummary.Groups.RadiationTherapy.RadiationType',
      defaultMessage: 'Type: ',
    },
    energyDisplay: {
      id: 'treatmentSummary.Groups.RadiationTherapy.EnergyDisplay',
      defaultMessage: 'Energy: ',
    },
    provider: {
      id: 'treatmentSummary.Groups.RadiationTherapy.Provider',
      defaultMessage: 'Care Provider: ',
    },
    institution: {
      id: 'treatmentSummary.Groups.RadiationTherapy.Institution',
      defaultMessage: 'Facility: ',
    },
    providerPhone: {
      id: 'treatmentSummary.Groups.RadiationTherapy.ProviderPhone',
      defaultMessage: 'Phone: ',
    },
    providerEmail: {
      id: 'treatmentSummary.Groups.RadiationTherapy.ProviderEmail',
      defaultMessage: 'Email: ',
    },
    elapsedDays: {
      id: 'treatmentSummary.Groups.RadiationTherapy.ElapsedDays',
      defaultMessage: 'Elapsed Days: ',
    },
    laterality: {
      id: 'treatmentSummary.Groups.RadiationTherapy.Laterality',
      defaultMessage: 'Laterality: ',
    },
    configuration: {
      id: 'treatmentSummary.Groups.RadiationTherapy.Configuration',
      defaultMessage: 'Configuration: ',
    },
    comment: {
      id: 'treatmentSummary.Groups.RadiationTherapy.Comment',
      defaultMessage: 'Comment: ',
    },
  },
};
